<div class="table-operations">
    <button nz-button nzType="primary" [nzSize]="'large'" [routerLink]="'/admin/teachers/add'">
        <i nz-icon nzType="usergroup-add" nzTheme="outline"></i>
        添加教师</button>
</div>
<nz-table #classTable [nzData]="displayData"
          [nzFrontPagination]="false"
          [nzPageSize]="10"
          [nzLoading]="this.loadingData"
          [(nzPageIndex)]="currentPageIndex"
          (nzPageIndexChange)="loadData($event)"
          [nzTotal]="totalTeacher">
    <thead>
    <tr>
        <th>序号</th>
        <th>教师</th>
        <th>电话</th>
        <th style="text-align: center">操作</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of classTable.data">
        <!--<td>{{data.id}}</td>-->
        <td>{{data.numId}}</td>
        <td>{{data.name}}</td>
        <td>{{data.phone}}</td>
        <td style="width:20rem">
            <div class="operations">
                <a nz-popconfirm nzPopconfirmTitle="确定删除教师？"
                   (nzOnConfirm)="deleteTeacher(data.id)" >
                    删除
                </a>
                <a (click)=" editTeacher(data.id)">编辑</a>
                <a (click)=" resetTeacherPw(data.id, data.phone)">重置密码</a>
                <a title="允许教师开通自己班级的学生帐号" *ngIf="1">
                    <label nz-checkbox [(ngModel)]="data.canManage"  (ngModelChange)="changeTeachPermission($event, data)">可开通帐号</label>
                </a>
            </div>

        </td>
    </tr>
    </tbody>
</nz-table>
